import styled from 'styled-components';
import { Button } from '@rsos/base-components';

export const IconButton = styled(Button)`
  width: 20px;
`;
